module.exports = __webpack_public_path__ + "img/09.8512e2d6.jpg";